import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "profile-wrap" }
const _hoisted_2 = { class: "profile-body w-100" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "d-flex flex-row my-2 align-items-center" }
const _hoisted_5 = { class: "message-image avatar-handle" }
const _hoisted_6 = { class: "avatar-img" }
const _hoisted_7 = { class: "profile-title flex-grow-1 ms-2 my-0" }
const _hoisted_8 = {
  key: 0,
  class: "profile-meta flex-grow-0"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 1,
  class: "action flex-grow-0"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "profile-bubble clearfix" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "action flex-grow-0" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatars flex-grow-1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MinusCircleOutline = _resolveComponent("MinusCircleOutline")!
  const _component_Send = _resolveComponent("Send")!
  const _directive_auth_image = _resolveDirective("auth-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: '/messages/'+_ctx.profile.id,
              title: _ctx.t('privatemessage')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                  [_directive_auth_image, _ctx.imageUrl]
                ])
              ]),
              _: 1
            }, 8, ["to", "title"])
          ]),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.profile.givenName === "" ? _ctx.profile.email : "") + _toDisplayString(_ctx.profile.givenName) + " " + _toDisplayString(_ctx.profile.surName), 1),
          (!_ctx.invite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('created')) + " " + _toDisplayString(_ctx.dateTime2(_ctx.profile.createdAt)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.invite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.isSubscribed())
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "ms-1 btn btn-lg btn-light btn-rounded",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.subscribe(false)), ["prevent"]))
                    }, [
                      _createVNode(_component_MinusCircleOutline, { class: "pencil" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.t('uninvite')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isSubscribed())
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "ms-1 btn btn-lg btn-light btn-rounded",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.subscribe(true)), ["prevent"]))
                    }, [
                      _createVNode(_component_Send, { class: "send" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.t('invite')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11
      ]),
      _hoisted_12,
      _hoisted_13
    ])
  ]))
}